import gql from "graphql-tag";

export const LiveCargoFragment = gql`
    fragment LiveCargoFragment on CargoNode {
        _id,
        name,
        customerID {
            _id
            name
        }
        approvedBy
        weight
        checkedInTime
        deliveredBy
        attentionTo
        groundPickup
        hazmat
        hazmatUnCode
        destinationID {
            _id
            name
        }
        departureID {
            _id
            name
        }
        transitType
        currentCarrierID {
            _id
            desig
        }
        tpID {
            _id
        }
        chargeCode
    }
`

export const SetCargo = gql`
    mutation LiveCargo_SetCargo($payload: CargoNodeInput!){
        setCargoNode(payload: $payload){
            ...LiveCargoFragment
        }
    }
    ${LiveCargoFragment}
`

export default gql`
query GetCgo(
    $filter: CargoFilterInput
    $bookmark: String
    $limit: Int
){
    cargo(
        filter: $filter
        bookmark: $bookmark
        limit: $limit
    ) {
        bookmark
        docs {
            _id,
            ... on CargoNode {
                ...LiveCargoFragment
            }
        }
    }
}
${LiveCargoFragment}
`
